import * as React from 'react';

function Svg24Youtube( props ){
  return (
    <svg width={ 24 }
      height={ 24 }
      role='img'
      { ...props }
      alt='Youtube'
    >
      <title>Youtube</title>
      <path
        d='M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm4.441 16.892c-2.102.144-6.784.144-8.883 0C5.282 16.736 5.017 15.622 5 12c.017-3.629.285-4.736 2.558-4.892 2.099-.144 6.782-.144 8.883 0C18.718 7.264 18.982 8.378 19 12c-.018 3.629-.285 4.736-2.559 4.892zM10 9.658l4.917 2.338L10 14.342V9.658z'
        fill='currentColor'
        fillRule='nonzero'
      />
    </svg>
  );
}

export default Svg24Youtube;
